export type DuplicateAction = {
  description: string
  id: DuplicateActions
}
export enum DuplicateActions {
  Keep,
  Termiante
}
